import { type ReactNode, useRef, useState } from "react";
import "./DropDownDatePicker.scss";
import PopMenu from "@/shared/components/generic/pop-menu/PopMenu.tsx";
import DayCalendar from "@/shared/components/generic/date/DayCalendar.tsx";
import useDateFormat from "@/shared/utils/useDateFormat.ts";
import { DateStyle } from "@/shared/utils/Dates.ts";
import { DateTime } from "luxon";

interface Properties {
  timeZone: string;
  value: Date;
  onChange: (d: Date) => void;
  shouldDisableDate?: (d: DateTime) => boolean;
}

export default function DropDownDatePicker(props: Properties): ReactNode {
  const [calendarOpen, setCalendarOpen] = useState(false);
  const anchorEl = useRef<HTMLDivElement>(null);
  const formatDate = useDateFormat(
    DateStyle.WEEKDAY_DATE_MONTH_YEAR,
    props.timeZone,
  );
  const toggleCalendarOpen = (): void => {
    setCalendarOpen((open) => !open);
  };
  const closeCalendar = (): void => {
    setCalendarOpen(false);
  };

  return (
    <div className="drop-down-date-picker" ref={anchorEl}>
      <div onClick={toggleCalendarOpen}>
        <div className="date-button">
          <div>{formatDate(props.value)}</div>
          <div className="chevron-icon" />
        </div>
      </div>
      <PopMenu
        open={calendarOpen}
        anchorEl={anchorEl.current}
        onClose={closeCalendar}
        placement={"bottom"}
      >
        <DayCalendar
          date={DateTime.fromJSDate(props.value)}
          onDateChanged={(val) => {
            props.onChange(val.toJSDate());
          }}
          onDateSet={closeCalendar}
          shouldDisableDate={props.shouldDisableDate}
        />
      </PopMenu>
    </div>
  );
}
